import { render, staticRenderFns } from "./changePro.vue?vue&type=template&id=06df1567&scoped=true&"
import script from "./changePro.vue?vue&type=script&lang=js&"
export * from "./changePro.vue?vue&type=script&lang=js&"
import style0 from "./changePro.vue?vue&type=style&index=0&id=06df1567&scoped=true&lang=css&"
import style1 from "./changePro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df1567",
  null
  
)

export default component.exports